var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_vm._l((_vm.filteredTabs),function(sTab,iTab){return _c('div',{key:iTab,staticClass:"tab",class:{ active: sTab.name === _vm.tabActive },on:{"click":function($event){return _vm.changeTab(sTab)}}},[_c('p',{staticClass:"tab-name"},[_vm._v(_vm._s(sTab.name))])])}),_c('div',{staticClass:"border",style:(`width: ${100 / _vm.tabs.length}%; transform: translateX(${
      _vm.tabActived * 100
    }%) `)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }